export enum ContextCategories {
  Page = 'page',
  Picker = 'picker',
}
